import { ReturnOrderListItemV2 } from 'services/api/refund';
import { useLazadaOrderReturnDetailContext } from './context';
import { Confirm, ConfirmReturnRefund } from 'components/Refund';
import { Refuse } from 'components/Refund/Refuse';
import { useMemo } from 'react';
import ForwardToAgent from 'components/Refund/ForwardToAgent';
import { message } from 'antd';
import { useTranslate } from '@tolgee/react';
import { UseLazadaReturnOpsReturn } from 'hooks/business/chat/useLazadaReturnOps';

interface OrderReturnFooterProps {
  returnOrder: ReturnOrderListItemV2;
  externalTradeId: string;
  platform: General.Platform;
  onUpdate: () => void;
  lazadaReturnOps: UseLazadaReturnOpsReturn;
  contactEnable?: boolean;
}

export const LazadaOrderReturnFooter = (props: OrderReturnFooterProps) => {
  const {
    returnOrder,
    externalTradeId,
    onUpdate,
    lazadaReturnOps: { confirmDisabled, confirmReturnRefundDisabled, refuseDisabled },
  } = props;
  const { internalStoreId, unit, externalStoreId, returnSn, returnItemData } = returnOrder;
  const { checkReturnOrderItemIds } = useLazadaOrderReturnDetailContext();
  const { t } = useTranslate();

  console.log('checkReturnOrderItemIds', checkReturnOrderItemIds);

  const refundAmount = useMemo(() => {
    let refundAmount = 0;
    for (const id of checkReturnOrderItemIds) {
      const target = returnItemData.find((_) => {
        const { returnOrderItemId = undefined } = _;

        return returnOrderItemId === id;
      });
      if (target) {
        refundAmount += target.refundAmount || 0;
      }
    }
    return refundAmount;
  }, [checkReturnOrderItemIds, returnItemData]);

  const hasSelected = useMemo(() => {
    return checkReturnOrderItemIds.length > 0;
  }, [checkReturnOrderItemIds]);

  const handleClickConfirmCheck = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!hasSelected) {
      e.preventDefault();
      e.stopPropagation();
      message.warn(t('请先选中商品'));
      return;
    }
  };

  return (
    <div className="flex items-center gap-4">
      <Confirm
        type="primary"
        size="middle"
        externalStoreId={externalStoreId}
        externalTradeId={externalTradeId}
        returnSn={returnSn}
        onSuccess={onUpdate}
        operate="CONFIRM"
        platform="LAZADA"
        returnOrderItemId={checkReturnOrderItemIds}
        disabled={confirmDisabled}
        unit={unit}
        refundAmount={refundAmount}
        onClick={handleClickConfirmCheck}
      />
      <ConfirmReturnRefund
        type="primary"
        size="middle"
        externalStoreId={externalStoreId}
        externalTradeId={externalTradeId}
        returnSn={returnSn}
        platform="LAZADA"
        returnOrderItemId={checkReturnOrderItemIds}
        disabled={confirmReturnRefundDisabled}
        onSucceed={onUpdate}
        onClick={handleClickConfirmCheck}
      />
      <Refuse
        type="primary"
        size="middle"
        internalStoreId={internalStoreId}
        externalStoreId={externalStoreId}
        returnSn={returnSn}
        returnOrderItemId={checkReturnOrderItemIds}
        onRefused={onUpdate}
        disabled={refuseDisabled}
        onClick={handleClickConfirmCheck}
      />
      <ForwardToAgent size="middle" />
    </div>
  );
};
